import { render, staticRenderFns } from "./ThemeModule.vue?vue&type=template&id=bc5569c8&scoped=true"
import script from "./ThemeModule.vue?vue&type=script&lang=js"
export * from "./ThemeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5569c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5569c8')) {
      api.createRecord('bc5569c8', component.options)
    } else {
      api.reload('bc5569c8', component.options)
    }
    module.hot.accept("./ThemeModule.vue?vue&type=template&id=bc5569c8&scoped=true", function () {
      api.rerender('bc5569c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/ThemeModule.vue"
export default component.exports